module.exports = __webpack_public_path__ + "static/media/community-builder-2.82633765.png";